import { getStorage } from '../utils'

const state = {
	// 字体规格类型: 可选择[normal big large]
	fontSizeType: getStorage('fontSizeType', 'normal')
}
export default state

export type State = typeof state
